module.exports = __webpack_public_path__ + "static/media/OLDER_KID_COMPATIBLE.29db8ff5.svg";